import React from 'react'
import PropTypes from 'prop-types'
import BlockContent from '../shared/blockContent'
import { buildImageObj } from '../../lib/helpers'
import { imageUrlFor } from '../../lib/image-url'
import { useViewport } from '../../containers/useViewport'

import './chequerboard.css'

const Chequerboard = ({ data }) => {
  const { width } = useViewport()

  let wrapperStyle = {
    backgroundImage: '',
  }
  if (data.config && data.config.bleed && data.media && typeof data.media.asset === 'object') {
    wrapperStyle.backgroundImage = `url(${imageUrlFor(buildImageObj(data.media.asset)).url()})`
  } else if (data.config && data.config.bleed && data.media && data.media.asset) {
    wrapperStyle.backgroundImage = `url(${data.media.asset})`
  }
  const titleColor =
    data.content.title && data.content.title.color ? data.content.title.color : 'black'

  const currentAsset =
    data.media.mobileAsset && width / 16 < 48 ? data.media.mobileAsset : data.media.asset

  return (
    <section
      className={
        'chequerboard' +
        (data.config && data.config.bleed ? ' bleed' : '') +
        (data.config && data.config.reverse ? ' reverse' : '') +
        (data.config && data.config.largeText ? ' largeText' : '') +
        (data.config && data.config.offset ? ' offset' : '') +
        (data.config && data.config.wide ? ' wide' : '') +
        (data.config && data.config.largeImages ? ' largeImages' : '')
      }
      style={wrapperStyle}
    >
      <div className="inner">
        <div className="media">
          {(width / 16 < 48 || data.media.isAnimated || !data.config.bleed) && (
            <img
              src={imageUrlFor(buildImageObj(currentAsset)).width(width).url()}
              alt={data.media.alt || ''}
            ></img>
          )}
        </div>
        <div className="content">
          {data.content && data.content.title && data.content.title.text && (
            <h2 className={`text-${titleColor}`}>{data.content.title.text}</h2>
          )}
          {typeof data.content.text === 'string' ? (
            <p>{data.content.text}</p>
          ) : (
            <BlockContent input={data.content.text}></BlockContent>
          )}
        </div>
      </div>
    </section>
  )
}

Chequerboard.propTypes = {
  data: PropTypes.object,
}

Chequerboard.defaultProps = {
  data: {
    config: {
      reverse: false,
      bleed: false,
    },
    content: {
      title: {
        text: 'Component title',
        color: 'red-light',
      },
      text:
        'This is some component text just to demo the flow. It will likely be replaced with portable text later.',
    },
    media: {
      asset: 'clients.png',
      alt: 'Content image',
    },
  },
}

export default Chequerboard
